module.exports = '2.1.5';



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphlib/lib/version.js
// module id = 437
// module chunks = 0